<template>
  <main v-loading.fullscreen.lock="loading">
    <div class="back-btn" @click="goSchool()">
      <i class="el-icon-s-home" />
      <span>学校主页</span>
    </div>
    <iframe
      v-if="liveDetail.status == 1 && liveDetail.review_url"
      :src="liveDetail.review_url"
      frameborder="0"
      style="width: 100%; height: 100%; min-height: 15rem;"
    />
    <a v-else-if="liveDetail.status == 3" :href="liveDetail.live_url" class="view_box">
      <div class="play" />
      <el-image class="video-cover" :src="liveDetail.live_cover || DefaultCover" />
    </a>
    <el-image v-else-if="liveDetail.live_cover" class="video-cover" :src="liveDetail.live_cover" />
    <div class="tabs">
      <div class="tab-item" :data-actived="activedTab === 0" @click="activedTab = 0">
        <el-image v-if="activedTab === 0" class="tab-icon" :src="InfoIcon" fit="cover" />
        <span>直播介绍</span>
      </div>
      <div class="tab-item" :data-actived="activedTab === 1" @click="activedTab = 1">
        <el-image v-if="activedTab === 1" class="tab-icon" :src="SchoolIcon" fit="cover" />
        <span>院校详情</span>
      </div>
    </div>
    <div v-if="activedTab === 0" class="broadcast-info">
      <div class="live-title-box">
        <div class="live-title-content">
          <h1>{{ liveDetail.title }}</h1>
          <div class="live-info">
            <div class="live-time">
              <el-image class="time-icon" :src="TimeIcon" fit="cover" />
              <span>{{ liveDetail.live_time }}</span>
            </div>
            <div class="viewer-count">
              <i class="el-icon-view" />
              <span>{{ liveDetail.view_count }}</span>
            </div>
          </div>
        </div>
        <div v-if="liveDetail.status == 2 && !liveDetail.is_subscribe" class="subscribe-area" :class="statusColor" @click="weChatAuth">
          <el-image class="subscribe-icon" :src="SubscribeIcon" fit="cover" />
          <span class="subscribe-text">提醒我</span>
          <wx-open-subscribe v-if="authInfo.openid" id="subscribe-btn" ref="subscribe-btn" template="xE1HS2vV9-Qi4vS_qG-vUaOJ3shFXIvv4Km_lpVfQsg">
            <component :is="'script'" type="text/wxtag-template">
              <button style="width: 100%; height: 100%; background: transparent; border: none;" />
            </component>
          </wx-open-subscribe>
        </div>
        <div v-else-if="liveDetail.status == 2 && liveDetail.is_subscribe" class="subscribe-area" :class="statusColor" @click="unsubscribeLive">
          <el-image class="subscribe-icon" :src="SubscribeIcon" fit="cover" />
          <span class="subscribe-text">取消提醒</span>
        </div>
        <div v-else class="subscribe-area" :class="statusColor">
          <el-image class="subscribe-icon" :src="statusIcon" fit="cover" />
          <span class="subscribe-text">{{ statusText }}</span>
        </div>
      </div>
      <div class="broadcast-introduce">
        <div v-html="liveDetail.content" />
      </div>
    </div>
    <div v-if="activedTab === 1" class="instituition-info">
      <InstitutionCard :card-data="schoolInfo" />
      <div class="title-box">
        <h2>直播列表</h2>
        <span>共{{ recommendLiveList.length }}场直播</span>
      </div>
      <div class="list-box">
        <ListCard v-for="item in recommendLiveList" :key="item.id" :card-data="item" />
      </div>
    </div>
  </main>
</template>

<script>
import wx from 'weixin-js-sdk';
import InstitutionCard from '../components/InstitutionCard';
import ListCard from '../components/ListCard';
import { getLiveDetail, getUserInfo, jsdkSignature, subscribeLive } from '@/api/customer';
import DefaultCover from '@/assets/images/default_cover.png';
import InfoIcon from '@/assets/images/icons/broadcast/info-detail.svg';
import SchoolIcon from '@/assets/images/icons/broadcast/info-school.svg';
import TimeIcon from '@/assets/images/icons/broadcast/info-time.svg';
import SubscribeIcon from '@/assets/images/icons/broadcast/live-subscribe.svg';
import StatusReady from "@/assets/images/icons/broadcast/status-ready.svg";
import StatusLiving from "@/assets/images/icons/broadcast/status-living.svg";
import StatusEnd from "@/assets/images/icons/broadcast/status-ended.svg";
import StatusReplay from "@/assets/images/icons/broadcast/status-replayed.svg";
export default {
  metaInfo() {
    return {
      title: this.schoolInfo.live_title || '招生直播宣讲会',
      meta: [
        {
          name: 'keywords',
          content: ''
        },
        {
          name: 'description',
          content: ''
        }
      ]
    }
  },
  components: {
    InstitutionCard,
    ListCard
  },
  data() {
    return {
      templateId: 'xE1HS2vV9-Qi4vS_qG-vUaOJ3shFXIvv4Km_lpVfQsg',
      loading: false,
      DefaultCover,
      InfoIcon,
      SchoolIcon,
      TimeIcon,
      SubscribeIcon,
      StatusReady,
      StatusLiving,
      StatusEnd,
      StatusReplay,
      authInfo: {
        openid: localStorage.getItem('authInfo')
      },
      activedTab: 0,
      schoolInfo: {},
      liveDetail: {},
      recommendLiveList: [],
    }
  },
  computed: {
    statusIcon() {
      switch (this.liveDetail.status) {
        case 1:
          if (this.liveDetail.review_url) {
            return this.StatusReplay;
          }
          return this.StatusEnd;
        case 2:
          return this.StatusReady;
        case 3:
          return this.StatusLiving;
        default:
          return this.StatusEnd;
      }
    },
    statusText() {
      switch (this.liveDetail.status) {
        case 1:
          if (this.liveDetail.review_url) {
            return '看回放';
          }
          return '已结束';
        case 2:
          return '待直播';
        case 3:
          return '直播中';
        default:
          return '已结束';
      }
    },
    statusColor() {
      switch (this.liveDetail.status) {
        case 1:
          return 'end-clor';
        case 2:
          return 'ready-clor';
        case 3:
          return 'living-clor';
        default:
          return 'end-clor';
      }
    }
  },
  async mounted() {
    this.loading = true;
    if (this.isWechat()) {
      if (!this.authInfo.openid && this.$route.query.code) {
        const state = this.$route.query.state;
        const code = this.$route.query.code;
        if (state === 'live') { // 直播详情页获取微信code
          if (code) {
            const { statusCode, data } = await getUserInfo({ code })
            if (statusCode === 0) {
              this.authInfo = data.authInfo;
              localStorage.setItem('authInfo', data.authInfo.openid);
            } else {
              this.weChatAuth();
            }
          }
        }
      }
      // 微信订阅-分享
      const { data: wxData } = await jsdkSignature({ url: location.href });
      wx.config({
        debug: false,
        appId: wxData.appId,
        timestamp: wxData.timestamp,
        nonceStr: wxData.nonceStr,
        signature: wxData.signature,
        jsApiList: [ // 这里是需要用到的接口名称
          'checkJsApi', // 判断当前客户端版本是否支持指定JS接口
          'updateAppMessageShareData', // 分享
          'updateTimelineShareData', // 分享朋友圈
          'getLocation', // 获取位置
          'openLocation', // 打开位置
          'scanQRCode', // 扫一扫接口
          'chooseWXPay', // 微信支付
          'chooseImage', // 拍照或从手机相册中选图接口
          'previewImage', // 预览图片接口
          'uploadImage' // 上传图片
        ],
        openTagList: ["wx-open-subscribe"], // 必填，需要使用的JS接口列表
      });

      // 监听订阅按钮加载完成
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
            const btn = document.getElementById('subscribe-btn');
            btn.addEventListener('success', (e) => {
              console.log('success', JSON.parse(e.detail.subscribeDetails));
              const result = JSON.parse(e.detail.subscribeDetails);
              if (result[this.templateId] === '{"status":"accept"}') {
                this.subscribeLive();
              }
            });
            btn.addEventListener('error', (e) => {
              console.log('fail', e.detail);
            });
          }
        });
      });
      const subscribeArea = document.querySelector('.subscribe-area');
      observer.observe(subscribeArea, {
        childList: true
      });
    }

    const { statusCode, data } = await getLiveDetail({ id: this.$route.params.id, openid: this.authInfo.openid });
    if (statusCode === 0) {
      this.schoolInfo = data.school
      this.liveDetail = data.liveDetail
      this.recommendLiveList = data.recommendLiveList
    }

    if (this.isWechat()) {
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: this.liveDetail.title,
          desc: `主讲人: ${this.liveDetail.teacher}`,
          link: location.href,
          imgUrl: this.schoolInfo.logo,
          success: function() {
            // 设置成功
            console.log('分享至聊天窗口成功');
          },
          fail: function() {
            console.log('分享至聊天窗口失败');
          }
        });
        // 分享到朋友圈及分享到QQ空间
        wx.updateTimelineShareData({
          title: this.liveDetail.title,
          desc: `主讲人: ${this.liveDetail.teacher}`,
          link: location.href,
          imgUrl: this.schoolInfo.logo,
          success: function() {
            // 设置成功
            console.log('分享朋友圈成功');
          },
          fail: function() {
            console.log('分享朋友圈失败');
          }
        });
      });
    }
    this.loading = false;
  },
  methods: {
    goSchool() {
      this.$router.push({
        path: `/m/broadcast/list/${this.schoolInfo.id}`,
      })
    },
    async subscribeLive() {
      this.loading = true;
      const { statusCode } = await subscribeLive({
        openid: this.authInfo.openid,
        live_id: this.liveDetail.id,
        status: 1
      });
      if (statusCode === 0) {
        console.log('subscribeLive: success');
        this.liveDetail.is_subscribe = 1;
      }
      this.loading = false;
      this.$message({
        message: '订阅提醒消息成功',
        type: 'success',
      });
    },
    async unsubscribeLive() {
      this.loading = true;
      const { statusCode } = await subscribeLive({
        openid: this.authInfo.openid,
        live_id: this.liveDetail.id,
        status: 0
      });
      if (statusCode === 0) {
        console.log('subscribeLive: success');
        this.liveDetail.is_subscribe = 0;
      }
      this.loading = false;
      this.$message({
        message: '取消提醒消息成功',
        type: 'success',
      });
    },

    // 判断是否在微信
    isWechat() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/micromessenger/i) == 'micromessenger') { // eslint-disable-line
        return true;
      } else {
        return false;
      }
    },
    // 微信授权链接
    weChatAuth() {
      if (!this.authInfo.openid) {
        this.$message({
          message: '正在跳转到微信授权页面',
          type: 'info',
          offset: 200,
          onClose: () => {
            const appid = 'wxe7d78bfd6e9dff2f';
            const redirect_uri = encodeURIComponent(`${process.env.VUE_APP_SITE_DOMAIN}/m/broadcast/detail/${this.$route.params.id}`);
            const authUrl =
              `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=live#wechat_redirect`;
            window.location.href = authUrl;
          }
        });
      }
    },
  }
};
</script>

<style>
#subscribe-btn {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-tap-highlight-color: transparent;
}
</style>
<style lang="less" scoped>
main {
  width: 100%;
  background: linear-gradient(to bottom, #1760E1, #E4EFFF 13rem, #FFFFFF 40rem);

  .back-btn {
    position: fixed;
    width: 6.5rem;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    right: 0;
    bottom: 10rem;
    border-radius: 1.5rem 0 0 1.5rem;
    font-size: 0.875rem;
    background-color: #00000066;
    color: #FFFFFF;
    z-index: 999;

    i {
      font-size: 1.5rem;
    }
  }

  .view_box {
    width: 100%;
    position: relative;

    .play {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      background: url('/robots/images/icons/play.png') no-repeat;
      width: 3rem;
      height: 3rem;
      background-size: 3rem 3rem;
      z-index: 99;
    }
  }

  .live-cover {
    width: 100%;
    min-height: 13.25rem;
  }

  .tabs {
    width: 100%;
    padding: 0.75rem  1.5rem;
    display: flex;
    align-items: center;
    gap: 1.25rem;

    .tab-item {
      display: flex;
      align-items: center;
      gap: 0.25rem;

      .tab-icon {
        width: 1.25rem;
        height: 1.25rem;
      }
      span {
        font-size: 0.875rem;
        color: #333333;
      }

      &[data-actived="true"] {
        span {
          font-size: 1rem;
          font-weight: bold;
          color: #000000;
        }
      }
    }
  }

  .broadcast-info {
    width: 100%;

    .live-title-box {
      margin: 0 1rem;
      padding: 0.25rem;
      width: calc(100% - 2rem);

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(45deg, #FFFFFF 30%, #2F5EF6);
        border-radius: 0.875rem;
        z-index: 1;
      }

      .live-title-content {
        width: 100%;
        background-color: #FFFFFF;
        border-radius: 0.75rem;
        padding: 1rem;
        z-index: 3;

        h1 {
          font-size: 1rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .live-info {
          margin-top: 1rem;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 0.875rem;

          .live-time {
            display: flex;
            align-items: center;
            gap: 0.5rem;

            .time-icon {
              width: 1rem;
              height: 1rem;
            }
          }

          .viewer-count {
            display: flex;
            align-items: center;
            gap: 0.25rem;
          }
        }
      }

      .subscribe-area {
        width: 7rem;
        height: 4rem;
        padding-bottom: 2rem;
        border-radius: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        position: absolute;
        right: 0;
        top: -2.25rem;
        z-index: 0;

        &.end-clor {
          background-color: #A0A0A0;
        }
        &.ready-clor {
          background-color: #2F5EF6;
        }
        &.living-clor {
          background-color: #FFA600;
        }

        .subscribe-icon {
          width: 1.5rem;
          height: 1.5rem;
        }
        span {
          font-size: 0.875rem;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }

    .broadcast-introduce {
      width: 100%;
      padding: 1rem;

      ::v-deep {
        p {
          word-break: break-all;
          margin: 0.5rem 0;
          font-size: 0.875rem !important;
        }
        text, span {
          font-size: 0.875rem !important;
          word-break: break-all;
        }
        img {
          max-width: 100%;
        }
        table {
          border-collapse: collapse;
          box-sizing: border-box;
          outline: none;
          tbody {
            tr th {
              background-color: #f2f4f7;
              font-weight: 600;
              text-align: center;
              border: 1px solid #dedede;
              padding: 3px 5px;
            }
            tr td {
              border: 1px solid #dedede;
              line-height: 1.5;
              min-width: 30px;
              height: 30px;
              padding: 3px 5px;
              text-align: left;
              display: table-cell;
            }
          }
        }
      }
    }
  }

  .instituition-info {
    width: 100%;
    padding: 0 1rem;

    .title-box {
      margin-top: 2rem;
      padding: 0 1.5rem;
      width: 100%;
      height: 3.25rem;
      background: url("~@/assets/images/backgrounds/broadcast/title-banner.webp");
      background-size: cover;
      color: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .list-box {
      margin-top: 1rem;
    }
  }
}
</style>
